module.exports = __webpack_public_path__ + "static/media/bts_lalela_170710_017_small.8047e185.jpg";